import type { FC } from 'react';
import { memo, useMemo } from 'react';
import type { Route } from '../../bootstrap/router/hooks';
import { Text, Title } from '../../bootstrap/typography';
import s from './index.module.scss';

export const ComingSoonPage: FC = memo(() => {
  return (
    <div className={s.page}>
      <Title size={1} color={1} className={s.title}>
        Coming soon
      </Title>
      <Text size="1" color="3" className={s.text}>
        This section is in the process of being created.
      </Text>
    </div>
  );
});

export const useComingSoonRoute = () => {
  const route = useMemo<Route>(
    () => ({
      path: '/coming-soon',
      element: ComingSoonPage
    }),
    []
  );

  return { route };
};
